import styles from '../Disco.module.css';

interface StoryBarsProps {
  index: number;
  total: number;
  showCount?: boolean;
  autoAdvance?: boolean;
  paused?: boolean;
  onComplete?: () => void;
}

export function StoryBars({
  index,
  total,
  showCount = true,
  autoAdvance = false,
  paused = false,
  onComplete,
}: StoryBarsProps) {
  return (
    <div className={styles.storyNav}>
      <div className={styles.storyBars}>
        {Array.from({ length: total }, (_, i) => (
          <div key={i} className={styles.storyBar}>
            {i < index || (i === index && !autoAdvance) ? (
              <i className={styles.storyBarFull} />
            ) : i === index ? (
              <i
                key={index}
                data-testid="story-progress"
                className={styles.storyBarFill}
                style={{ animationPlayState: paused ? 'paused' : 'running' }}
                onAnimationEnd={onComplete}
              />
            ) : null}
          </div>
        ))}
      </div>
      {showCount && (
        <span className={styles.storyCount}>
          {index + 1}/{total}
        </span>
      )}
    </div>
  );
}
